<template>
  <v-container class="vivid-arts-directory">

    <pulse-loader v-if="!directory" class="va-page-loader" :color="color" :size="size" :margin="margin" :radius="radius"></pulse-loader>
    <v-layout row wrap>

      <v-flex class="page-header mb-5" xs12 v-if="enterpriseLogo">
        <v-container fluid grid-list-md>
          <v-layout row wrap>
            <v-flex xs12 sm4>
              <v-card-media
                class="enterprise-logo"
                :src="enterpriseLogo"
                :contain="enterpriseLogoContain"
                height="100px"
              ></v-card-media>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>

      <v-flex xs12 v-if="directory && directory.enableHero && directory.gallery && directory.gallery.length">
        <swiper :options="swiperOption">
          <!-- slides -->
          <swiper-slide
            v-for="(item,i) in directory.gallery" v-bind:src="item.src" :key="i">
            <a v-if="item.url" :href="item.url">
              <div class="slider-img" :style="{backgroundImage: 'url('+item.src+')'}"></div>
              <div class="slider-caption-wrap" v-if="item.caption">
                <div class="caption-text">
                  {{item.caption}}
                </div>
              </div>
            </a>
            <div v-else>
              <div class="slider-img" :style="{backgroundImage: 'url('+item.src+')'}"></div>
              <div class="slider-caption-wrap" v-if="item.caption">
                <div class="caption-text">
                  {{item.caption}}
                </div>
              </div>
            </div>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
          <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
          <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
        </swiper>
      </v-flex>

      <!-- <v-flex xs12 v-if="enterprise && enterprise.artistHeroGallery && enterprise.artistHeroGallery.length">
        <v-carousel>
          <v-carousel-item
          v-for="(item,i) in enterprise.artistHeroGallery" v-bind:src="item" :key="i"></v-carousel-item>
        </v-carousel>
      </v-flex> -->

      <v-flex xs12 class="artist-search mt-5">
        <v-container fluid grid-list-md>
          <p class="headline">Filters</p>
          <v-layout row wrap>
            <v-flex xs12 sm12 md4 class="search-textfield-wrap">
              <v-text-field
                name="input-1-3"
                v-model="artistSearch"
                class="search-textfield"
                label="Search Artist"
                single-line
                prepend-icon="search"
              ></v-text-field>
              <a v-show="artistSearch" href class="clear-search btn" @click.prevent="artistSearch = ''"><v-icon>fa-times-circle</v-icon></a>
            </v-flex>
            <v-flex xs12 sm12 md4>
              <span v-show="false">{{viewableArtists.length}}/{{fRegions.length}}</span>
              <p>Region</p>
              <v-select v-bind:items="cities" v-model="dd1" overflow label="Select" class="capitalize"></v-select>
            </v-flex>
            <v-flex xs12 sm12 md4>
              <p>Type</p>
              <v-select v-bind:items="activeCategories" v-model="dd2" overflow item-value="name" item-text="name" label="Select"></v-select>
            </v-flex>
            <!-- <v-flex sm12 sm4 v-if="false">
              <p>Sub-Type</p>
              <v-select v-bind:items="activeCategories" v-model="dd3" overflow item-value="name" item-text="name" label="Select"></v-select>
            </v-flex> -->
          </v-layout>
        </v-container>
      </v-flex>

      <v-flex xs12 id="artist-grid-wrap" ref="artistGridWrap">
        <v-container fluid v-bind="{ [`grid-list-md`]: true }">
          <v-layout row wrap>
            <v-flex
              xs12 sm6 md4
              :key="artist['.key']"
              v-for="artist in viewableArtists"
              v-if="viewableArtists.length > 0"
              class="pa-4">
              <v-card flat tile>
                <router-link :to="{ name: 'ArtistProfile', params: { id: artist['.key']} }">
                  <v-card-media class="profile-image"
                    :src="artist.profileCloudinaryURL | thumbnailURL"
                    height="200px"
                  >
                  </v-card-media>
                </router-link>
                <v-card-title primary-title>
                  <div>
                    <router-link class="artist-name" :to="{ name: 'ArtistProfile', params: { id: artist['.key']} }">
                      <h3 class="headline mb-0">{{ artist.fullName }}</h3>
                    </router-link>
                    <div class="artist-expcert">{{ artist.excerpt | truncate(150) }}</div>
                  </div>
                </v-card-title>
                <v-card-actions>
                  <router-link class="indigo--text btn btn--flat" tag="button" :to="{ name: 'ArtistProfile', params: { id: artist['.key']} }">View Profile</router-link>
                  <!-- <router-link class="indigo--text btn btn--flat" tag="button" :to="{ name: 'EditArtist', params: { id: artist['.key']} }">Edit</router-link> -->
                </v-card-actions>
              </v-card>
            </v-flex>
            <v-flex v-if="viewableArtists.length === 0" xs12>
              <h2 class="headline text-xs-center">{{errorMsg}}</h2>
            </v-flex>
            <v-flex xs12 class="text-xs-center" v-if="viewableArtists.length">
              <v-pagination :length="numberOfPages" v-model="page" circle></v-pagination>
            </v-flex>
          </v-layout>
        </v-container>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

export default {
  name: 'Directory',
  components: {
    swiper,
    swiperSlide,
    PulseLoader
  },
  created () {
    this.fetchArtists()
    this.fetchEnterpriseDirectory()
  },
  data () {
    return {
      enterpriseLogo: window.VividArts.enterpriseLogo,
      enterpriseLogoContain: true,
      artistSearch: null,

      pageLoder: true,
      color: '#136FAB',
      size: '30px',

      scrollOptions: {
        el: '#artist-grid-wrap',
        easing: 'ease-in',
        offset: -200,
        cancelable: true,
        onDone: function () {
          // scrolling is done
        },
        onCancel: function () {
          // scrolling has been interrupted
        },
        x: false,
        y: true
      },
      page: 1,
      maxArtistCount: 6,
      numberOfPages: 0,
      dd1: null,
      dd2: null,
      dd3: null,
      artistTypes: window.VividArts.types || [],
      cities: [],
      enterprise: {},
      fRegions: [],

      activeCategories: [],
      directories: {},
      directory: {},
      directoryType: 'artists',
      errorMsg: 'No results found.',

      swiperOption: {
        pagination: '.swiper-pagination',
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        paginationClickable: true,
        spaceBetween: 30,
        loop: true,
        autoplay: 2500,
        effect: 'fade'
      },

      heroCarousel: [],

      originalActiveArtists: [],
      filteredArtists: [],
      viewableArtists: [],

      dropdown_regions: [],
      dropdown_icon: ['All', 'list', 'favorite', 'delete'],
      dropdown_edit: [
        { text: 'All' },
        { text: '100%' },
        { text: '75%' },
        { text: '50%' },
        { text: '25%' },
        { text: '0%' }
      ]
    }
  },
  watch: {
    dd1 (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.page = 1
        this.applyArtistFilters()
        this.filterArtistsByPage(this.filteredArtists)
      }
    },
    dd2 (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.page = 1
        this.applyArtistFilters()
        this.filterArtistsByPage(this.filteredArtists)
      }
    },
    page (newVal, oldVal) {
      if (newVal !== oldVal) {
        VueScrollTo.scrollTo('#artist-grid-wrap', 500, this.scrollOptions)
        this.filterArtistsByPage(this.filteredArtists)
      }
    },
    originalActiveArtists (newVal, oldVal) {
      if (typeof newVal !== 'undefined' && newVal.length > 0 && newVal !== oldVal) {
        this.applyArtistFilters()
        this.filterArtistsByPage(newVal)
      }
    },
    artistSearch (newVal, oldVal) {
      if (newVal !== oldVal) {
        if (newVal === '') {
          this.filterArtistsByPage(this.filteredArtists)
          return
        }
        console.log('artistSearch', newVal)
        var array = this.artistSearchHandler(newVal.toLowerCase(), this.originalActiveArtists, this.filteredArtists)
        if (typeof array !== 'undefined') {
          this.filterArtistsByPage(array)
          // console.log('artistSearch', newVal, array)
        }
      }
    }
  },
  computed: {},
  methods: {
    sortArtistsByName (a, b) {
      if (a.fullName < b.fullName) {
        return -1
      }
      if (a.fullName > b.fullName) {
        return 1
      }
      return 0
    },
    filterArtistsByPage (artists) {
      console.log('filterArtistsByPage')
      let mac = this.maxArtistCount
      let al = artists.length
      let start = (this.page - 1) * mac
      this.numberOfPages = Math.ceil(al / mac)
      let rtn = Vue._.clone(artists, true).splice(start, mac)
      // console.log('numberOfPages', al, mac, this.numberOfPages, rtn)
      this.viewableArtists = rtn
    },
    applyArtistFilters () {
      let dd1Val = this.dd1 || 'All'
      let dd2Val = this.dd2 || 'All'
      // console.log('filtering artist by region', dd1Val)
      // console.log('filtering artist by category', dd2Val)
      this.filteredArtists = this.originalActiveArtists
      .filter(function (item) {
        // console.log(item.regionId, dd1Val)
        if (dd1Val === 'All') {
          return true
        } else if (typeof item.city !== 'undefined' && item.city.toLowerCase().indexOf(dd1Val.toLowerCase()) >= 0) {
          return true
        }
        return false
      })
      .filter(function (item) {
        // console.log(item.fullName, item, dd2Val)
        if (dd2Val === 'All') {
          return true
        } else if (typeof item.styles !== 'undefined') {
          // debugger
          if (typeof item.styles !== 'undefined' && Array.isArray(item.styles) && item.styles.indexOf(dd2Val) >= 0) {
            return true
          }
        }
        return false
      })
      .sort(this.sortArtistsByName)
    },
    artistSearchHandler (str, arr, arr2) {
      // var str = this.artistSearch
      // console.log('Searching for ', str, arr, arr2)
      if (typeof arr === 'undefined') {
        return
      }
      return arr.filter(function (item) {
        // console.log(item.fullName.toLowerCase(), str, (item.fullName.toLowerCase().indexOf(str) >= 0))
        return item.fullName.toLowerCase().indexOf(str) >= 0
      })
    },
    heroClickHandler (item) {
      if (typeof item.url !== 'undefined') {
        console.log('heroClickHandler', item.url)
      }
    },
    fetchArtists () {
      // console.log('fetch artists')
      var url = this.$store.state.apiURL + '/artists'
      this.axios.get(url, this.$store.state.axiosConfig).then((response) => {
        var keys = Object.keys(response.data)
        var data = Object.values(response.data)
        .map(function (item, idx) {
          item['.key'] = keys[idx]
          return item
        })
        // console.log('API | artists', data)

        var placeholderArtistImg = this.$store.state.placeholderArtistImg
        var artists = data.filter(function (artist) {
          return artist.status === 'active' && (artist.enableDirectoryListing === true)
        })
        .map(function (item) {
          if (typeof item.bio !== 'undefined') {
            item.bio = unescape(item.bio)
          }
          if (typeof item.fullName !== 'undefined') {
            item.fullName = unescape(item.fullName)
          }
          if (typeof item.excerpt !== 'undefined') {
            item.excerpt = unescape(item.excerpt)
          }
          if (typeof item.profileCloudinaryURL === 'undefined' || item.profileCloudinaryURL === '') {
            item.profileCloudinaryURL = placeholderArtistImg
          }
          return item
        })
        .sort(this.sortArtistsByName)

        var titleCase = this.titleCase
        this.cities = Array.from(new Set(artists.map(function (item) {
          return (typeof item.city !== 'undefined') ? titleCase(item.city.toLowerCase()) : ''
        })))
        .sort()
        console.log('Artists cities', this.cities)

        this.cities.unshift('All')

        // console.log('setting artists', artists)
        // this.viewableArtists = Vue._.clone(artists, false)
        this.originalActiveArtists = artists
        // this.filterItemsByStatus(this.status)
      })
    },
    fetchEnterpriseDirectory () {
      // console.log('fetch enterprise directory', this.$store.state, this.$store.state.apiURL)
      let id = window.VividArts.eId
      if (typeof id === 'undefined' || id === '') {
        this.errorMsg = 'Invalid connection.'
        return
      }
      var requestURL = this.$store.state.apiURL + '/enterprises/' + id + '/directory'
      // var payload = { }
      var vm = this
      this.axios.get(requestURL, this.$store.state.axiosConfig).then((response) => {
        var data = response.data
        console.log('fetchEnterpriseDirectory', data)
        vm.directories = data
        // console.log('API | enterprise directory', data, vm.directoryType)
        if (data === null) { return }

        vm.directory = data[vm.directoryType] ? Vue._.clone(data[vm.directoryType], false) : {}
        console.log('directoryType ->')
        if (vm.directoryType === 'artists') {
          vm.activeCategories = vm.directory.categories
          if (typeof vm.activeCategories !== 'undefined' && vm.activeCategories.length > 0) {
            vm.activeCategories.unshift({name: 'All'})
          } else {
            vm.activeCategories = [{name: 'All'}]
          }
        }
        if (typeof vm.directory.loop !== 'undefined') {
          vm.swiperOption.loop = vm.directory.loop
        }
        if (typeof vm.directory.autoplay !== 'undefined') {
          vm.swiperOption.autoplay = vm.directory.autoplay
        }
        if (typeof vm.directory.effect !== 'undefined') {
          vm.swiperOption.effect = vm.directory.effect
        }
        if (typeof vm.directory.direction !== 'undefined') {
          vm.swiperOption.direction = vm.directory.direction
        }
        if (typeof vm.directory.itemsPerPage !== 'undefined') {
          vm.maxArtistCount = vm.directory.itemsPerPage
        }
        // console.log('active directory', vm.directory)
        // this.form = this.initFormWithData(this.artist)
      })
    },
    titleCase (str) {
      var splitStr = str.toLowerCase().split(' ')
      for (var i = 0; i < splitStr.length; i++) {
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1)
      }
      return splitStr.join(' ')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.page-header .enterprise-logo .card__media__background {
  background-position: left center !important;
}

.vivid-arts-directory .artist-search .search-textfield {
  margin-top: 36px;
}

.slider-img{
  width: 100%;
  height: 500px;
  display: block;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
}

.va-page-loader{
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -51px;
  z-index: 99999;
  display: block;
}
</style>





<style>
/**
 * Swiper 3.4.1
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 *
 * http://www.idangero.us/swiper/
 *
 * Copyright 2016, Vladimir Kharlampidi
 * The iDangero.us
 * http://www.idangero.us/
 *
 * Licensed under MIT
 *
 * Released on: December 13, 2016
 */
.swiper-container {
  margin-left: auto;
  margin-right: auto;
  position: relative;
  overflow: hidden;
  /* Fix of Webkit flickering */
  z-index: 1;
}
.swiper-container-no-flexbox .swiper-slide {
  float: left;
}
.swiper-container-vertical > .swiper-wrapper {
  -webkit-box-orient: vertical;
  -moz-box-orient: vertical;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
}
.swiper-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-transition-property: -webkit-transform;
  -moz-transition-property: -moz-transform;
  -o-transition-property: -o-transform;
  -ms-transition-property: -ms-transform;
  transition-property: transform;
  -webkit-box-sizing: content-box;
  -moz-box-sizing: content-box;
  box-sizing: content-box;
}
.swiper-container-android .swiper-slide,
.swiper-wrapper {
  -webkit-transform: translate3d(0px, 0, 0);
  -moz-transform: translate3d(0px, 0, 0);
  -o-transform: translate(0px, 0px);
  -ms-transform: translate3d(0px, 0, 0);
  transform: translate3d(0px, 0, 0);
}
.swiper-container-multirow > .swiper-wrapper {
  -webkit-box-lines: multiple;
  -moz-box-lines: multiple;
  -ms-flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
}
.swiper-container-free-mode > .swiper-wrapper {
  -webkit-transition-timing-function: ease-out;
  -moz-transition-timing-function: ease-out;
  -ms-transition-timing-function: ease-out;
  -o-transition-timing-function: ease-out;
  transition-timing-function: ease-out;
  margin: 0 auto;
}
.swiper-slide {
  -webkit-flex-shrink: 0;
  -ms-flex: 0 0 auto;
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  position: relative;
}
/* Auto Height */
.swiper-container-autoheight,
.swiper-container-autoheight .swiper-slide {
  height: auto;
}
.swiper-container-autoheight .swiper-wrapper {
  -webkit-box-align: start;
  -ms-flex-align: start;
  -webkit-align-items: flex-start;
  align-items: flex-start;
  -webkit-transition-property: -webkit-transform, height;
  -moz-transition-property: -moz-transform;
  -o-transition-property: -o-transform;
  -ms-transition-property: -ms-transform;
  transition-property: transform, height;
}
/* a11y */
.swiper-container .swiper-notification {
  position: absolute;
  left: 0;
  top: 0;
  pointer-events: none;
  opacity: 0;
  z-index: -1000;
}
/* IE10 Windows Phone 8 Fixes */
.swiper-wp8-horizontal {
  -ms-touch-action: pan-y;
  touch-action: pan-y;
}
.swiper-wp8-vertical {
  -ms-touch-action: pan-x;
  touch-action: pan-x;
}
/* Arrows */
.swiper-button-prev,
.swiper-button-next {
  position: absolute;
  top: 50%;
  width: 27px;
  height: 44px;
  margin-top: -22px;
  z-index: 10;
  cursor: pointer;
  -moz-background-size: 27px 44px;
  -webkit-background-size: 27px 44px;
  background-size: 27px 44px;
  background-position: center;
  background-repeat: no-repeat;
}
.swiper-button-prev.swiper-button-disabled,
.swiper-button-next.swiper-button-disabled {
  opacity: 0.35;
  cursor: auto;
  pointer-events: none;
}
.swiper-button-prev,
.swiper-container-rtl .swiper-button-next {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l2.1%2C2.1L4.2%2C22l19.9%2C19.9L22%2C44L0%2C22L0%2C22L0%2C22z'%20fill%3D'%23007aff'%2F%3E%3C%2Fsvg%3E");
  left: 10px;
  right: auto;
}
.swiper-button-prev.swiper-button-black,
.swiper-container-rtl .swiper-button-next.swiper-button-black {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l2.1%2C2.1L4.2%2C22l19.9%2C19.9L22%2C44L0%2C22L0%2C22L0%2C22z'%20fill%3D'%23000000'%2F%3E%3C%2Fsvg%3E");
}
.swiper-button-prev.swiper-button-white,
.swiper-container-rtl .swiper-button-next.swiper-button-white {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l2.1%2C2.1L4.2%2C22l19.9%2C19.9L22%2C44L0%2C22L0%2C22L0%2C22z'%20fill%3D'%23ffffff'%2F%3E%3C%2Fsvg%3E");
}
.swiper-button-next,
.swiper-container-rtl .swiper-button-prev {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%23007aff'%2F%3E%3C%2Fsvg%3E");
  right: 10px;
  left: auto;
}
.swiper-button-next.swiper-button-black,
.swiper-container-rtl .swiper-button-prev.swiper-button-black {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%23000000'%2F%3E%3C%2Fsvg%3E");
}
.swiper-button-next.swiper-button-white,
.swiper-container-rtl .swiper-button-prev.swiper-button-white {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%23ffffff'%2F%3E%3C%2Fsvg%3E");
}
/* Pagination Styles */
.swiper-pagination {
  position: absolute;
  text-align: center;
  -webkit-transition: 300ms;
  -moz-transition: 300ms;
  -o-transition: 300ms;
  transition: 300ms;
  -webkit-transform: translate3d(0, 0, 0);
  -ms-transform: translate3d(0, 0, 0);
  -o-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
  z-index: 10;
}
.swiper-pagination.swiper-pagination-hidden {
  opacity: 0;
}
/* Common Styles */
.swiper-pagination-fraction,
.swiper-pagination-custom,
.swiper-container-horizontal > .swiper-pagination-bullets {
  bottom: 10px;
  left: 0;
  width: 100%;
}
/* Bullets */
.swiper-pagination-bullet {
  width: 8px;
  height: 8px;
  display: inline-block;
  border-radius: 100%;
  background: #000;
  opacity: 0.2;
}
button.swiper-pagination-bullet {
  border: none;
  margin: 0;
  padding: 0;
  box-shadow: none;
  -moz-appearance: none;
  -ms-appearance: none;
  -webkit-appearance: none;
  appearance: none;
}
.swiper-pagination-clickable .swiper-pagination-bullet {
  cursor: pointer;
}
.swiper-pagination-white .swiper-pagination-bullet {
  background: #fff;
}
.swiper-pagination-bullet-active {
  opacity: 1;
  background: #007aff;
}
.swiper-pagination-white .swiper-pagination-bullet-active {
  background: #fff;
}
.swiper-pagination-black .swiper-pagination-bullet-active {
  background: #000;
}
.swiper-container-vertical > .swiper-pagination-bullets {
  right: 10px;
  top: 50%;
  -webkit-transform: translate3d(0px, -50%, 0);
  -moz-transform: translate3d(0px, -50%, 0);
  -o-transform: translate(0px, -50%);
  -ms-transform: translate3d(0px, -50%, 0);
  transform: translate3d(0px, -50%, 0);
}
.swiper-container-vertical > .swiper-pagination-bullets .swiper-pagination-bullet {
  margin: 5px 0;
  display: block;
}
.swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet {
  margin: 0 5px;
}
/* Progress */
.swiper-pagination-progress {
  background: rgba(0, 0, 0, 0.25);
  position: absolute;
}
.swiper-pagination-progress .swiper-pagination-progressbar {
  background: #007aff;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  -webkit-transform: scale(0);
  -ms-transform: scale(0);
  -o-transform: scale(0);
  transform: scale(0);
  -webkit-transform-origin: left top;
  -moz-transform-origin: left top;
  -ms-transform-origin: left top;
  -o-transform-origin: left top;
  transform-origin: left top;
}
.swiper-container-rtl .swiper-pagination-progress .swiper-pagination-progressbar {
  -webkit-transform-origin: right top;
  -moz-transform-origin: right top;
  -ms-transform-origin: right top;
  -o-transform-origin: right top;
  transform-origin: right top;
}
.swiper-container-horizontal > .swiper-pagination-progress {
  width: 100%;
  height: 4px;
  left: 0;
  top: 0;
}
.swiper-container-vertical > .swiper-pagination-progress {
  width: 4px;
  height: 100%;
  left: 0;
  top: 0;
}
.swiper-pagination-progress.swiper-pagination-white {
  background: rgba(255, 255, 255, 0.5);
}
.swiper-pagination-progress.swiper-pagination-white .swiper-pagination-progressbar {
  background: #fff;
}
.swiper-pagination-progress.swiper-pagination-black .swiper-pagination-progressbar {
  background: #000;
}
/* 3D Container */
.swiper-container-3d {
  -webkit-perspective: 1200px;
  -moz-perspective: 1200px;
  -o-perspective: 1200px;
  perspective: 1200px;
}
.swiper-container-3d .swiper-wrapper,
.swiper-container-3d .swiper-slide,
.swiper-container-3d .swiper-slide-shadow-left,
.swiper-container-3d .swiper-slide-shadow-right,
.swiper-container-3d .swiper-slide-shadow-top,
.swiper-container-3d .swiper-slide-shadow-bottom,
.swiper-container-3d .swiper-cube-shadow {
  -webkit-transform-style: preserve-3d;
  -moz-transform-style: preserve-3d;
  -ms-transform-style: preserve-3d;
  transform-style: preserve-3d;
}
.swiper-container-3d .swiper-slide-shadow-left,
.swiper-container-3d .swiper-slide-shadow-right,
.swiper-container-3d .swiper-slide-shadow-top,
.swiper-container-3d .swiper-slide-shadow-bottom {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 10;
}
.swiper-container-3d .swiper-slide-shadow-left {
  background-image: -webkit-gradient(linear, left top, right top, from(rgba(0, 0, 0, 0.5)), to(rgba(0, 0, 0, 0)));
  /* Safari 4+, Chrome */
  background-image: -webkit-linear-gradient(right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
  /* Chrome 10+, Safari 5.1+, iOS 5+ */
  background-image: -moz-linear-gradient(right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
  /* Firefox 3.6-15 */
  background-image: -o-linear-gradient(right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
  /* Opera 11.10-12.00 */
  background-image: linear-gradient(to left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
  /* Firefox 16+, IE10, Opera 12.50+ */
}
.swiper-container-3d .swiper-slide-shadow-right {
  background-image: -webkit-gradient(linear, right top, left top, from(rgba(0, 0, 0, 0.5)), to(rgba(0, 0, 0, 0)));
  /* Safari 4+, Chrome */
  background-image: -webkit-linear-gradient(left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
  /* Chrome 10+, Safari 5.1+, iOS 5+ */
  background-image: -moz-linear-gradient(left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
  /* Firefox 3.6-15 */
  background-image: -o-linear-gradient(left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
  /* Opera 11.10-12.00 */
  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
  /* Firefox 16+, IE10, Opera 12.50+ */
}
.swiper-container-3d .swiper-slide-shadow-top {
  background-image: -webkit-gradient(linear, left top, left bottom, from(rgba(0, 0, 0, 0.5)), to(rgba(0, 0, 0, 0)));
  /* Safari 4+, Chrome */
  background-image: -webkit-linear-gradient(bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
  /* Chrome 10+, Safari 5.1+, iOS 5+ */
  background-image: -moz-linear-gradient(bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
  /* Firefox 3.6-15 */
  background-image: -o-linear-gradient(bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
  /* Opera 11.10-12.00 */
  background-image: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
  /* Firefox 16+, IE10, Opera 12.50+ */
}
.swiper-container-3d .swiper-slide-shadow-bottom {
  background-image: -webkit-gradient(linear, left bottom, left top, from(rgba(0, 0, 0, 0.5)), to(rgba(0, 0, 0, 0)));
  /* Safari 4+, Chrome */
  background-image: -webkit-linear-gradient(top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
  /* Chrome 10+, Safari 5.1+, iOS 5+ */
  background-image: -moz-linear-gradient(top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
  /* Firefox 3.6-15 */
  background-image: -o-linear-gradient(top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
  /* Opera 11.10-12.00 */
  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
  /* Firefox 16+, IE10, Opera 12.50+ */
}
/* Coverflow */
.swiper-container-coverflow .swiper-wrapper,
.swiper-container-flip .swiper-wrapper {
  /* Windows 8 IE 10 fix */
  -ms-perspective: 1200px;
}
/* Cube + Flip */
.swiper-container-cube,
.swiper-container-flip {
  overflow: visible;
}
.swiper-container-cube .swiper-slide,
.swiper-container-flip .swiper-slide {
  pointer-events: none;
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  -ms-backface-visibility: hidden;
  backface-visibility: hidden;
  z-index: 1;
}
.swiper-container-cube .swiper-slide .swiper-slide,
.swiper-container-flip .swiper-slide .swiper-slide {
  pointer-events: none;
}
.swiper-container-cube .swiper-slide-active,
.swiper-container-flip .swiper-slide-active,
.swiper-container-cube .swiper-slide-active .swiper-slide-active,
.swiper-container-flip .swiper-slide-active .swiper-slide-active {
  pointer-events: auto;
}
.swiper-container-cube .swiper-slide-shadow-top,
.swiper-container-flip .swiper-slide-shadow-top,
.swiper-container-cube .swiper-slide-shadow-bottom,
.swiper-container-flip .swiper-slide-shadow-bottom,
.swiper-container-cube .swiper-slide-shadow-left,
.swiper-container-flip .swiper-slide-shadow-left,
.swiper-container-cube .swiper-slide-shadow-right,
.swiper-container-flip .swiper-slide-shadow-right {
  z-index: 0;
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  -ms-backface-visibility: hidden;
  backface-visibility: hidden;
}
/* Cube */
.swiper-container-cube .swiper-slide {
  visibility: hidden;
  -webkit-transform-origin: 0 0;
  -moz-transform-origin: 0 0;
  -ms-transform-origin: 0 0;
  transform-origin: 0 0;
  width: 100%;
  height: 100%;
}
.swiper-container-cube.swiper-container-rtl .swiper-slide {
  -webkit-transform-origin: 100% 0;
  -moz-transform-origin: 100% 0;
  -ms-transform-origin: 100% 0;
  transform-origin: 100% 0;
}
.swiper-container-cube .swiper-slide-active,
.swiper-container-cube .swiper-slide-next,
.swiper-container-cube .swiper-slide-prev,
.swiper-container-cube .swiper-slide-next + .swiper-slide {
  pointer-events: auto;
  visibility: visible;
}
.swiper-container-cube .swiper-cube-shadow {
  position: absolute;
  left: 0;
  bottom: 0px;
  width: 100%;
  height: 100%;
  background: #000;
  opacity: 0.6;
  -webkit-filter: blur(50px);
  filter: blur(50px);
  z-index: 0;
}
/* Fade */
.swiper-container-fade.swiper-container-free-mode .swiper-slide {
  -webkit-transition-timing-function: ease-out;
  -moz-transition-timing-function: ease-out;
  -ms-transition-timing-function: ease-out;
  -o-transition-timing-function: ease-out;
  transition-timing-function: ease-out;
}
.swiper-container-fade .swiper-slide {
  pointer-events: none;
  -webkit-transition-property: opacity;
  -moz-transition-property: opacity;
  -o-transition-property: opacity;
  transition-property: opacity;
}
.swiper-container-fade .swiper-slide .swiper-slide {
  pointer-events: none;
}
.swiper-container-fade .swiper-slide-active,
.swiper-container-fade .swiper-slide-active .swiper-slide-active {
  pointer-events: auto;
}
.swiper-zoom-container {
  width: 100%;
  height: 100%;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -moz-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  text-align: center;
}
.swiper-zoom-container > img,
.swiper-zoom-container > svg,
.swiper-zoom-container > canvas {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}
/* Scrollbar */
.swiper-scrollbar {
  border-radius: 10px;
  position: relative;
  -ms-touch-action: none;
  background: rgba(0, 0, 0, 0.1);
}
.swiper-container-horizontal > .swiper-scrollbar {
  position: absolute;
  left: 1%;
  bottom: 3px;
  z-index: 50;
  height: 5px;
  width: 98%;
}
.swiper-container-vertical > .swiper-scrollbar {
  position: absolute;
  right: 3px;
  top: 1%;
  z-index: 50;
  width: 5px;
  height: 98%;
}
.swiper-scrollbar-drag {
  height: 100%;
  width: 100%;
  position: relative;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 10px;
  left: 0;
  top: 0;
}
.swiper-scrollbar-cursor-drag {
  cursor: move;
}
/* Preloader */
.swiper-lazy-preloader {
  width: 42px;
  height: 42px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -21px;
  margin-top: -21px;
  z-index: 10;
  -webkit-transform-origin: 50%;
  -moz-transform-origin: 50%;
  transform-origin: 50%;
  -webkit-animation: swiper-preloader-spin 1s steps(12, end) infinite;
  -moz-animation: swiper-preloader-spin 1s steps(12, end) infinite;
  animation: swiper-preloader-spin 1s steps(12, end) infinite;
}
.swiper-lazy-preloader:after {
  display: block;
  content: "";
  width: 100%;
  height: 100%;
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20viewBox%3D'0%200%20120%20120'%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20xmlns%3Axlink%3D'http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink'%3E%3Cdefs%3E%3Cline%20id%3D'l'%20x1%3D'60'%20x2%3D'60'%20y1%3D'7'%20y2%3D'27'%20stroke%3D'%236c6c6c'%20stroke-width%3D'11'%20stroke-linecap%3D'round'%2F%3E%3C%2Fdefs%3E%3Cg%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(30%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(60%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(90%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(120%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(150%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.37'%20transform%3D'rotate(180%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.46'%20transform%3D'rotate(210%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.56'%20transform%3D'rotate(240%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.66'%20transform%3D'rotate(270%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.75'%20transform%3D'rotate(300%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.85'%20transform%3D'rotate(330%2060%2C60)'%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E");
  background-position: 50%;
  -webkit-background-size: 100%;
  background-size: 100%;
  background-repeat: no-repeat;
}
.swiper-lazy-preloader-white:after {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20viewBox%3D'0%200%20120%20120'%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20xmlns%3Axlink%3D'http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink'%3E%3Cdefs%3E%3Cline%20id%3D'l'%20x1%3D'60'%20x2%3D'60'%20y1%3D'7'%20y2%3D'27'%20stroke%3D'%23fff'%20stroke-width%3D'11'%20stroke-linecap%3D'round'%2F%3E%3C%2Fdefs%3E%3Cg%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(30%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(60%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(90%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(120%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(150%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.37'%20transform%3D'rotate(180%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.46'%20transform%3D'rotate(210%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.56'%20transform%3D'rotate(240%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.66'%20transform%3D'rotate(270%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.75'%20transform%3D'rotate(300%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.85'%20transform%3D'rotate(330%2060%2C60)'%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E");
}
@-webkit-keyframes swiper-preloader-spin {
  100% {
    -webkit-transform: rotate(360deg);
  }
}
@keyframes swiper-preloader-spin {
  100% {
    transform: rotate(360deg);
  }
}
.slider-caption-wrap{
  width:100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(255,255,255,.5);
  display: block;
  opacity: 0;

  -webkit-transition: opacity .3s;
  transition: opacity .3s;
}
.slider-caption-wrap:hover{
  opacity: 1;
}
.caption-text{
  text-align: center;
  font-size: 3em;
  margin-top: 20%;
}
.profile-image .card__media__background{
  background-position: center 20% !important;
}
.artist-name{
  text-decoration: none;
  width: 100%;
}
.search-textfield-wrap{
  position: relative;
}
.search-textfield-wrap .clear-search.btn{
  position: absolute;
  top: 0;
  right: 0px;
  margin-top: 60px;
  min-width: 24px;
  width: 24px;
  height: 24px;
}
</style>


// WEBPACK FOOTER //
// Directory.vue?4e316264